
import { defineComponent, computed } from 'vue'
import { NuxeoUpdatePasswordResponse } from '@/contracts/api/ResponseContracts'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Heading from '@/components/Heading.vue'
import { nuxeoUpdatePassword } from '@/composables/nuxeo'

export default defineComponent(
{
    name: 'ForgottenPassword',
    components:
    {
        Heading
    },
    setup()
    {
        // Load router:
        const router = useRouter()
        // Load vuex:
        const store = useStore()

        // Get form data:
        const loginData = store.getters['formData/loginData']

        nuxeoUpdatePassword(
        {
            email: loginData.email
        },
        function(response: NuxeoUpdatePasswordResponse)
        {
            // console.log(response)
        })

        // Return data:
        return {
            loginData
        }
    }
})
